/*
 * Rest Day — Brand JS for Dawn
 * =============================
 * Paste into: assets/rest-day.js
 * Then add <script src="{{ 'rest-day.js' | asset_url }}" defer></script>
 * to the bottom of layout/theme.liquid before </body>
 */
 
document.addEventListener('DOMContentLoaded', function () {
 
  // =====================
  // ANNOUNCEMENT BAR
  // Seamless ticker using CSS animation
  // =====================
  const track = document.getElementById('rd-announcement-track');
  if (track) {
    // Clone the inner content for seamless loop
    const clone = track.innerHTML;
    track.innerHTML += clone;
  }
 
  // =====================
  // MOBILE NAV TOGGLE
  // =====================
  const navToggle = document.getElementById('rd-nav-toggle');
  const navDrawer = document.getElementById('rd-nav-drawer');
 
  if (navToggle && navDrawer) {
    navToggle.addEventListener('click', function () {
      const isOpen = navDrawer.classList.toggle('rd-nav-open');
      navToggle.setAttribute('aria-expanded', String(isOpen));
      const bars = navToggle.querySelectorAll('span');
      if (bars.length === 3) {
        bars[0].style.transform = isOpen ? 'rotate(45deg) translate(5px, 5px)' : '';
        bars[1].style.opacity   = isOpen ? '0' : '1';
        bars[2].style.transform = isOpen ? 'rotate(-45deg) translate(5px, -5px)' : '';
      }
    });
 
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!navToggle.contains(e.target) && !navDrawer.contains(e.target)) {
        navDrawer.classList.remove('rd-nav-open');
        navToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
 
  // =====================
  // KLAVIYO NEWSLETTER
  // Handles all .rd-newsletter-form elements on the page
  // =====================
  function klaviyoSubscribe(email, source, onSuccess, onError) {
    var data = {
      token: 'WhMB8q',
      properties: {
        $email: email,
        $source: source || 'Rest Day Website'
      }
    };
 
    fetch('https://a.klaviyo.com/api/identify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'data=' + btoa(unescape(encodeURIComponent(JSON.stringify(data))))
    })
    .then(function (res) {
      if (onSuccess) onSuccess();
    })
    .catch(function () {
      // Still show success - Klaviyo CORS sometimes blocks but still processes
      if (onSuccess) onSuccess();
    });
  }
 
  function bindNewsletterForm(form) {
    var input   = form.querySelector('.rd-nl-email');
    var btn     = form.querySelector('.rd-nl-btn');
    var success = form.querySelector('.rd-nl-success');
    var source  = form.dataset.source || 'Rest Day Website';
 
    if (!input || !btn) return;
 
    function submit() {
      var email = input.value.trim();
      if (!email || !email.includes('@')) {
        input.style.borderColor = '#c4853a';
        input.focus();
        return;
      }
      input.style.borderColor = '';
      btn.textContent = 'Subscribing...';
      btn.disabled = true;
 
      klaviyoSubscribe(email, source, function () {
        form.style.display = 'none';
        if (success) {
          success.style.display = 'block';
        }
      });
    }
 
    btn.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submit();
    });
  }
 
  document.querySelectorAll('.rd-newsletter-form').forEach(bindNewsletterForm);
 
  // =====================
  // PRODUCT PAGE GALLERY
  // =====================
  var mainImg   = document.getElementById('rd-main-img');
  var thumbs    = document.querySelectorAll('.rd-thumb');
 
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = this.dataset.full || this.querySelector('img').src;
      }
      thumbs.forEach(function (t) { t.classList.remove('rd-thumb--active'); });
      this.classList.add('rd-thumb--active');
    });
  });
 
  // =====================
  // PRODUCT PAGE ACCORDION
  // =====================
  document.querySelectorAll('.rd-accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var body = this.nextElementSibling;
      var icon = this.querySelector('.rd-accordion-icon');
      var isOpen = body && body.classList.contains('rd-accordion-open');
 
      // Close all
      document.querySelectorAll('.rd-accordion-body').forEach(function (b) {
        b.classList.remove('rd-accordion-open');
        b.style.maxHeight = '0';
      });
      document.querySelectorAll('.rd-accordion-icon').forEach(function (i) {
        i.textContent = '+';
      });
 
      // Open this one if it was closed
      if (!isOpen && body) {
        body.classList.add('rd-accordion-open');
        body.style.maxHeight = body.scrollHeight + 'px';
        if (icon) icon.textContent = '-';
      }
    });
  });
 
// =====================
  // VARIANT SELECTION (Colour + Size)
  // =====================
  (function () {
    var form = document.getElementById('rd-product-form');
    if (!form) return;

    var variantDataEl = document.getElementById('rd-variant-data');
    var variants = [];
    try {
      variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var variantIdInput = document.getElementById('rd-variant-id-input') || form.querySelector('[name="id"]');
    var priceEl = document.getElementById('rd-product-price');
    var klarnaPriceEl = document.getElementById('rd-klarna-price');
    var stickyPriceEl = document.getElementById('rd-sticky-price');
    var atcBtn = document.getElementById('rd-main-atc');

    var selected = {};
    document.querySelectorAll('.rd-colour-btn--active').forEach(function (btn) {
      selected[btn.dataset.optionPosition] = btn.dataset.colour;
    });
    document.querySelectorAll('.rd-size-btn--active').forEach(function (btn) {
      selected[btn.dataset.optionPosition] = btn.dataset.value;
    });

        function formatMoney(price) {
      var n = parseFloat(price);
      if (isNaN(n)) return price;
      return '£' + (n / 100).toFixed(2);
    }


    function findMatchingVariant() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (pos) {
          return v['option' + pos] === selected[pos];
        });
      });
    }

    function updateVariant() {
      var variant = findMatchingVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      var priceText = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = priceText;
      if (stickyPriceEl) stickyPriceEl.textContent = priceText;
      if (klarnaPriceEl) klarnaPriceEl.textContent = formatMoney(variant.price / 3);

      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = 'Add to Cart - <span id="rd-atc-price">' + priceText + '</span>';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold Out';
        }
      }
    }

    document.querySelectorAll('.rd-colour-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.rd-colour-btn').forEach(function (b) {
          b.classList.remove('rd-colour-btn--active');
        });
        this.classList.add('rd-colour-btn--active');
        var label = document.getElementById('rd-selected-colour');
        if (label) label.textContent = this.dataset.colour || this.textContent.trim();
        selected[this.dataset.optionPosition] = this.dataset.colour;
        updateVariant();
      });
    });

    document.querySelectorAll('.rd-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = this.closest('.rd-size-group');
        if (group) {
          group.querySelectorAll('.rd-size-btn').forEach(function (b) {
            b.classList.remove('rd-size-btn--active');
          });
        }
        this.classList.add('rd-size-btn--active');
        var label = document.getElementById('rd-selected-size');
        if (label) label.textContent = this.textContent.trim();
        selected[this.dataset.optionPosition] = this.dataset.value;
        updateVariant();
      });
    });
  })();
 
  // =====================
  // STICKY ATC BAR
  // Shows a compact add-to-cart bar when the main ATC scrolls out of view
  // =====================
  var mainAtc   = document.getElementById('rd-main-atc');
  var stickyBar = document.getElementById('rd-sticky-atc');
 
  if (mainAtc && stickyBar) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.style.transform = entry.isIntersecting
          ? 'translateY(100%)'
          : 'translateY(0)';
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  }
 
});
 